import { FirebaseProvider } from '@chem-po/firebase-web'
import { CustomMessagePayload, PopUpMessageContext, useAuth } from '@hb/react'
import { RecaptchaVerifier } from 'firebase/auth'
import { onMessage } from 'firebase/messaging'
import { PropsWithChildren, useContext, useEffect } from 'react'
import { app } from '../backend/app'
import { auth } from '../backend/auth'
import { db } from '../backend/db/db'
import { functions } from '../backend/functions/functions'
import { messaging } from '../backend/messaging'
import { storage } from '../backend/storage/storage'
import { useAuthListeners } from '../hooks/backend/auth/useAuthListener'

export const WebFirebaseProvider = ({ children }: PropsWithChildren) => {
  const { showMessage } = useContext(PopUpMessageContext)
  useEffect(() => {
    useAuth.setState({
      recaptchaVerifier: new RecaptchaVerifier(auth, '2fa-recaptcha-container', {
        size: 'invisible',
        callback: () => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // useAuth.setState({ captcha: response })
        },
      }),
    })
  }, [])

  useEffect(
    () =>
      onMessage(messaging, payload => {
        const { data } = payload as unknown as CustomMessagePayload
        if (data) {
          showMessage({
            type: 'info',
            text: data.title ?? '',
            subText: data?.body,
            notificationData: data,
          })
        }
      }),
    [showMessage],
  )

  useAuthListeners(auth)
  return (
    <FirebaseProvider
      app={app}
      auth={auth}
      firestore={db}
      functions={functions}
      storage={storage}
      authProviders={[]}>
      {children}
    </FirebaseProvider>
  )
}
